import { buildReducer } from '../../../shared';
import { mailComposeClickedAction, mailComposePopoutOpenedAction } from '../../../editors/actions';
import type { MailComposeState } from '../../state/view/mailComposeState';

export default buildReducer<MailComposeState>()
    .handle(mailComposeClickedAction, (_state, action) => ({
        shouldShowMailCompose: true,
        to: action.payload.to,
        subject: action.payload.subject,
        body: action.payload.body,
    }))
    .handle(mailComposePopoutOpenedAction, (_state, action) => ({
        shouldShowMailCompose: false,
        to: undefined,
    }))
    .done({ shouldShowMailCompose: false, to: undefined });
export type { Action } from '../../../shared';
